import { useDispatch } from 'react-redux';
import { fetchJobList } from '~/components/JobList/ShiftList/utils';
import { useAppSelector } from '~/hooks/useAppSelector';
import { FilterStatusEnum } from './../../../../utils/Enum';

interface IProps {
  type:
    | typeof FilterStatusEnum.OPEN
    | typeof FilterStatusEnum.SCHEDULED
    | typeof FilterStatusEnum.PENDING;
}

export const useTable = ({ type }: IProps) => {
  const dispatch = useDispatch();
  const dashboardInfo = useAppSelector((state) => state.job.dashboardInfo);
  const jobListPagination = useAppSelector((state) => state.job.dashboardJobListPagination);
  const isLoadingFirstPage = jobListPagination?.page === 1 && jobListPagination?.isActiveRequest;
  const isLoading = jobListPagination?.isActiveRequest;

  let totalPages = 0;

  if (type === FilterStatusEnum.OPEN) {
    totalPages = Math.ceil(dashboardInfo?.activeRequest / 15);
  } else if (type === FilterStatusEnum.PENDING) {
    totalPages = Math.ceil(dashboardInfo?.actionRequired / 15);
  } else if (type === FilterStatusEnum.SCHEDULED) {
    totalPages = Math.ceil(dashboardInfo?.scheduled / 15);
  }

  const onPageChange = (page: number) => {
    dispatch(
      fetchJobList(type, {
        page,
      }),
    );
  };

  return {
    isLoadingFirstPage,
    isLoading,
    page: jobListPagination?.page,
    totalPages,
    onPageChange,
  };
};
